
// prettier-ignore
const template = (data) => `
<tr class="table__body-row">
    <th class="table__head-cell u-hidden@min-medium">table heading 1</th>
    <td class="table__body-cell">
        ${data.name}
    </td>
    <th class="table__head-cell u-hidden@min-medium">table heading 2</th>
    <td class="table__body-cell u-align-right@min-small">
        <a href="${data.downloadUrl}" data-behaviour="gtm-click" data-gtm-event="file-download" data-gtm-fileName="${data.name}"
            class="download-link link link--inline link--midnight link--underline u-weight-light">
            Download
            <svg width="18" height="18" class="download-link__icon u-mr0 u-ml">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#download"></use>
            </svg>
        </a>
    </td>
</tr>
`
export default template
